<template>
  <div>
    <base-header type="gradient-default" class="pb-6 pb-8 pt-5 pt-md-8">
      <div class="row">
        <div class="col-12 d-block d-md-none mb-3">
          <router-link
            :to="'/'"
            class="btn-link font-weight-normal text-white"
            title="Voltar para o início"
            ><i class="fas fa-chevron-left mr-1"></i> Voltar</router-link
          >
        </div>
        <div class="col-lg-4 d-flex align-items-stretch">
          <stats-card
            title="Reservas pendentes"
            type="gradient-primary"
            :sub-title="String(stats.pendingReservations)"
            icon="fas fa-clipboard-list"
            class="mb-4 mb-xl-0 flex-grow-1"
          >
            <template slot="footer">
              <span class="text-wrap">ao total até o momento</span>
            </template>
          </stats-card>
        </div>
        <div class="col-lg-4 d-flex align-items-stretch">
          <stats-card
            title="Reservas confirmadas"
            type="gradient-success"
            :sub-title="String(stats.confirmedReservations)"
            icon="fas fa-clipboard-check"
            class="mb-4 mb-xl-0 flex-grow-1"
          >
            <template slot="footer">
              <span class="text-wrap">ao total até o momento</span>
            </template>
          </stats-card>
        </div>
        <div class="col-lg-4 d-flex align-items-stretch">
          <stats-card
            title="Espaços"
            type="gradient-dark"
            :sub-title="String(stats.numRooms)"
            icon="fas fa-building"
            class="mb-4 mb-xl-0 flex-grow-1"
          >
            <template slot="footer">
              <span class="text-wrap">cadastrados ao total</span>
            </template>
          </stats-card>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-lg-12 mb-3">
          <div class="float-right">
            <base-button
              type="white"
              v-tooltip="'Abrir relatório detalhada'"
              @click="$router.push('/empresa/espacos/reservas/relatorio')"
              ><i class="fas fa-list text-success mr-2"></i> Relatório de
              reservas</base-button
            >
          </div>
        </div>
        <div class="col-xl-5 col-lg-12 order-xl-2">
          <espacos-table @stats="updateStats"></espacos-table>
        </div>
        <div class="col-xl-7 col-lg-12 mt-xl-0 mt-4">
          <reservas-table></reservas-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/services/api";

import EspacosTable from "./Espacos/EspacosTable";
import ReservasTable from "./Espacos/ReservasTable";

export default {
  components: {
    EspacosTable,
    ReservasTable
  },
  data() {
    return {
      stats: {
        numRooms: 0,
        pendingReservations: 0,
        confirmedReservations: 0
      }
    };
  },
  async mounted() {
    try {
      const { data } = await api.get(`/company/reservations-stats`);
      Object.assign(this.stats, data);
    } catch (e) {
      this.$toasted.error(`Ocorreu um erro ao recuperar as estatísticas`);
    }
  },
  methods: {
    updateStats(stats) {
      Object.assign(this.stats, stats);
    }
  }
};
</script>
<style></style>
